import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../../../components/AdminLayout/AdminLayout';
import DashboardMainContainer from '../../../../components/common/Containers/DashboardMainContainer';
import {
  AdminPageTitle,
  AdminPanelTitle,
  AdminSupportingText,
  AdminMetadataText,
  AdminStatusBadge,
  AdminFormSecondaryAction,
  AdminRowAction,
  ADMIN_TOOLBAR_CLASS,
  ADMIN_TABLE_CLASS,
} from '../../shared/adminUx';

// Demo blog data - will be replaced with WordPress API integration
const DEMO_BLOGS = [
  {
    id: 201,
    title: 'Old Article: Home Improvement Trends 2023',
    excerpt: 'This article has been removed and replaced with updated content...',
    author: 'John Smith',
    category: 'Trends',
    deletedDate: '2024-01-10',
    status: 'deleted',
  },
  {
    id: 202,
    title: 'Outdated: Summer Maintenance Tips',
    excerpt: 'This seasonal article has been archived and will be replaced with new content...',
    author: 'Sarah Johnson',
    category: 'Seasonal',
    deletedDate: '2024-01-05',
    status: 'deleted',
  },
  {
    id: 203,
    title: 'Removed: Product Review Post',
    excerpt: 'This product review has been removed due to product discontinuation...',
    author: 'Mike Williams',
    category: 'Reviews',
    deletedDate: '2023-12-28',
    status: 'deleted',
  },
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
};

const BlogDeleted = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Simulate API call - will be replaced with WordPress API integration
    const fetchBlogs = async () => {
      setLoading(true);
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        setBlogs(DEMO_BLOGS);
      } catch (error) {
        console.error('Error fetching deleted blogs:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBlogs();
  }, []);

  const handleRestore = (blogId) => {
    // TODO: Restore blog (will be implemented with WordPress integration)
    console.log('Restore blog:', blogId);
  };

  const handlePermanentDelete = (blogId) => {
    // TODO: Permanently delete blog (will be implemented with WordPress integration)
    if (window.confirm('Are you sure you want to permanently delete this article? This action cannot be undone.')) {
      console.log('Permanently delete blog:', blogId);
    }
  };

  if (loading) {
    return (
      <AdminLayout>
        <DashboardMainContainer className={ADMIN_TABLE_CLASS}>
          <div className="flex items-center justify-center h-96">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primaryblue"></div>
          </div>
        </DashboardMainContainer>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <div className="tp-container-main">
        <div>
        <AdminPageTitle>Deleted Articles</AdminPageTitle>
        <div className={ADMIN_TOOLBAR_CLASS}>
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
            <div className="flex-1" />
          </div>
        </div>

        {/* Blog List */}
        <DashboardMainContainer className={ADMIN_TABLE_CLASS}>
          {blogs.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16">
              <AdminSupportingText className="text-mediumgray text-center mb-4">No deleted articles found</AdminSupportingText>
              <AdminSupportingText className="text-mediumgray text-center">
                Deleted articles will appear here. They can be restored or permanently deleted.
              </AdminSupportingText>
            </div>
          ) : (
            <div className="space-y-4">
              {blogs.map((blog) => (
                <div
                  key={blog.id}
                  className="border border-lightgray rounded-lg p-4 hover:border-primaryblue transition-colors opacity-75"
                >
                  <div className="flex flex-col lg:flex-row gap-4">
                    {/* Content */}
                    <div className="flex-1 flex flex-col justify-between">
                      <div>
                        <div className="flex items-start justify-between gap-4 mb-2">
                          <AdminPanelTitle className="text-offblack line-clamp-2">{blog.title}</AdminPanelTitle>
                          <AdminStatusBadge status="Deleted" label="Deleted" className="whitespace-nowrap" />
                        </div>
                        <AdminSupportingText className="text-mediumgray mb-3 line-clamp-2 block">
                          {blog.excerpt}
                        </AdminSupportingText>
                        <div className="flex flex-wrap items-center gap-4">
                          <AdminMetadataText className="text-mediumgray">By {blog.author}</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">{blog.category}</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">•</AdminMetadataText>
                          <AdminMetadataText className="text-mediumgray">Deleted: {formatDate(blog.deletedDate)}</AdminMetadataText>
                        </div>
                      </div>

                      {/* Actions */}
                      <div className="flex gap-2 mt-4">
                        <AdminRowAction onClick={() => handleRestore(blog.id)}>
                          Restore
                        </AdminRowAction>
                        <AdminFormSecondaryAction
                          type="button"
                          className="!border-alertred !text-alertred hover:!bg-alertred hover:!text-white"
                          onClick={() => handlePermanentDelete(blog.id)}
                        >
                          Delete Permanently
                        </AdminFormSecondaryAction>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </DashboardMainContainer>
        </div>
      </div>
    </AdminLayout>
  );
};

export default BlogDeleted;

